import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./TVLAccidentConfirmed.scss";
import { Header, TitleBar } from "webapp/components";
import CallIcon from "@mui/icons-material/Call";
import travelerLogo from "assets/logo/TravelersLogo.png";

export default function TVLAccidentConfirmed(props) {
  const { t } = useTranslation();

  const [phoneNumber] = useState("800-252-4633");

  const ConfirmServiceObj = {
    img: travelerLogo,
    fragment: (
      <React.Fragment>
        <p>{t("description.TVLAccidentConfirmedTitleBar1")}</p>
      </React.Fragment>
    ),
  };

  return (
    <>
      <div className="view-accident-confirmed">
        <Header
          currState={props.currState}
          information={t("description.TVLAccidentConfirmedHeader")}
          disableBack={true}
        />
        <TitleBar data={ConfirmServiceObj} />
        <p className="message">
          <span>{t("description.TVLAccidentConfirmedMessage1")}</span>
          &nbsp;
          <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
          &nbsp;
          <span>{t("description.TVLAccidentConfirmedMessage2")}</span>
        </p>
        <a href={`tel:${phoneNumber}`} className="clickToDial">
          <CallIcon />
          <span>{phoneNumber}</span>
        </a>
      </div>
    </>
  );
}
